import { Button, InfoPage } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";
import { useIsSharedWithMeEnabled } from "../../hooks/useProjectSharing";
import { useTracker } from "../../hooks/useTracker";

// eslint-disable-next-line postcss-modules/no-unused-class
import style from "./RequestAccessPage.module.css";

export default function RequestAccessPendingPage() {
  const isSharedWithMeEnabled = useIsSharedWithMeEnabled();
  const tracker = useTracker();
  const { goToProfile } = useNavigation();

  const title = `Access Requested`;
  const message = `You can access the project once your request is approved.`;

  return (
    <InfoPage
      variant="success"
      title={title}
      description={<div className={style.message}>{message}</div>}
      primaryCTA={
        <Button
          variant="grayscale"
          onClick={() => {
            tracker.trackGoToDashboard({
              location: "request_access_page",
              destination: isSharedWithMeEnabled ? "shared_with_me" : "review_links",
            });
            goToProfile();
          }}
        >
          Go to Dashboard
        </Button>
      }
    />
  );
}
